export interface SumsubAccessTokenData {
  userId: string
  token: string
}

export enum SumsubMessage {
  Submitted = 'idCheck.onApplicantSubmitted',
  StepCompleted = 'idCheck.onStepCompleted',
  StatusChanged = 'idCheck.onApplicantStatusChanged',
  Error = 'idCheck.onError',
}

export interface SocketSumsubMessage {
  CreatedAt: string
  ReviewRejectType: SumsubReviewRejectType
  ReviewStatus: SumsubReviewStatus
  Type: SumsubWebhookType
  reviewAnswer: SumsubStatusAnswer
}

export enum SumsubStatusAnswer {
  Red = 'RED',
  Green = 'GREEN',
}

/** https://docs.sumsub.com/reference/get-applicant-review-status#review-statuses:~:text=Final%20rejection%20clarification.-,reviewRejectType,-String */
export enum SumsubReviewRejectType {
  Final = 'FINAL',
  Retry = 'RETRY',
  None = '',
}

/** https://docs.sumsub.com/reference/get-applicant-review-status#review-statuses */
export enum SumsubReviewStatus {
  Init = 'init',
  Pending = 'pending',
  Prechecked = 'prechecked',
  Queued = 'queued',
  Completed = 'completed',
  OnHold = 'onHold',
}

/** https://docs.sumsub.com/docs/user-verification-webhooks#applicantworkflowcompleted */
export enum SumsubWebhookType {
  ApplicantCreated = 'applicantCreated',
  ApplicantPending = 'applicantPending',
  ApplicantReviewed = 'applicantReviewed',
  ApplicantOnHold = 'applicantOnHold',
  ApplicantActionPending = 'applicantActionPending',
  ApplicantActionReviewed = 'applicantActionReviewed',
  ApplicantActionOnHold = 'applicantActionOnHold',
  ApplicantPersonalInfoChanged = 'applicantPersonalInfoChanged',
  ApplicantTagsChanged = 'applicantTagsChanged',
  ApplicantActivated = 'applicantActivated',
  ApplicantDeactivated = 'applicantDeactivated',
  ApplicantDeleted = 'applicantDeleted',
  ApplicantReset = 'applicantReset',
  ApplicantPrechecked = 'applicantPrechecked',
  ApplicantLevelChanged = 'applicantLevelChanged',
  /** This one means the workflow is done, and we should show the loading screen */
  ApplicantWorkflowCompleted = 'applicantWorkflowCompleted',
  ApplicantWorkflowFailed = 'applicantWorkflowFailed',
  VideoIdentStatusChanged = 'videoIdentStatusChanged',
  VideoIdentCompositionCompleted = 'videoIdentCompositionCompleted',
}
